<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.unidades"
                    :validations="validations.unidade"
                    @change="handleUnidadeChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="unidadeId"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }

        if (this.regulador) {

            this.loadRegulador()
        }
    },
    data: () => ({
        model: {
            id: null,
            ativo: true,
            unidadeId: null,
            infraestruturaId: null,
            exames: [],
            procedimentosCirurgicos: [],
            especialidades: [],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadRegulador() {

            Object.assign(this.model, this.regulador)

            this.loadInfraestruturas()
        },
        handleUnidadeChange() {

            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (this.model.unidadeId) {

                this.loadInfraestruturas()
            }
        },
        loadInfraestruturas() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                listar: 'infraestruturas',
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {

                    this.data.form.infraestruturas = data

                    if (this.data.form.infraestruturas.length === 1) {

                        this.model.infraestruturaId = this.data.form.infraestruturas[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (!this.divulgador && this.infraestruturaJaAdicionada()) {

                        this.showValidationNotification('O local de atendimento já foi incluído.')

                        return
                    }

                    if (this.divulgador) {

                        Object.assign(this.originalRegulador, this.prepareData())
                    }
                    else {

                        this.data.model.divulgacao.push(this.prepareData())
                    }

                    this.$emit('save')
                })
        },
        infraestruturaJaAdicionada() {

            return !!this.data.model.divulgacao.find(r => r.infraestruturaId === this.model.infraestruturaId)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.unidadeNomeFantasia = this.data.form.unidades.find(u => u.unidadeId === data.unidadeId).nomeFantasia
            data.infraestruturaNome = this.data.form.infraestruturas.find(u => u.id === data.infraestruturaId).nome

            return data
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
        originalRegulador: { type: Object },
        regulador: { type: Object },
    },
}
</script>